import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  initialState: {
    isLoggedIn: false,
    loading: true,
    user: null,
  },
  name: "user",
  reducers: {
    loginUser: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
    },
    logoutUser: (state) => {
      state.isLoggedIn = false;
      state.user = null;
    },
    setLoading: (state, val) => {
      state.loading = val.payload;
    }
  },
});

export default userSlice.reducer;
export const { loginUser, logoutUser, setLoading } = userSlice.actions;
